export default __webpack_public_path__ + "static/media/marketing.c8c7ecea.jpg";